module.exports = __webpack_public_path__ + "img/course-outline-bg.c2343ee1.png";